import { downloadTextFile } from '@fourthwall/utils/dist/downloadCsvFile'

import { useShopTime } from '../../../../../Timezone/providers/ShopTimeProvider'
import { useMembersDataQuery } from './useMembersDataQuery'

export const useMembersDataExport = () => {
  const { timezone } = useShopTime()
  const { membersDataQuery } = useMembersDataQuery({
    time_zone: timezone,
  })

  const exportMembersData = async () => {
    const membersData = await membersDataQuery.refetch()

    if (membersData.data) {
      downloadTextFile(membersData.data, 'members.csv')
    }
  }

  return {
    exportMembersData,
    isMembersDataLoading: membersDataQuery.isFetching,
  }
}
